define('views/pages/favorites/goods/navbar',['require','jquery','underscore','views/base/view','text!templates/pages/favorites/goods/navbar.ejs','views/filter-list'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        View = require('views/base/view'),
        template = require('text!templates/pages/favorites/goods/navbar.ejs'),
        FilterListView = require('views/filter-list');

    var FavoritesGoodsNavbarView = View.extend({
        region: 'favorites-goods-navbar',
        autoRender: true,
        className: 'navbar-inner',
        template: template,
        regions: {
            'navbar': '.menu-expand'
        },
        render: function() {
            View.prototype.render.apply(this, arguments);

            this.subview('filter-list', new FilterListView({ model: this.model.filterList }));

            var _this = this;

            $('.search-query', this.$el).on('input propertychange', _.debounce(function() {
                _this.model.set('search', $(this).val());
            }, 200));
        }
    });

    return FavoritesGoodsNavbarView;
});

